// ¿El usuario está mirando esta pestaña? Se exigen las dos cosas:
//  - visibilityState 'visible': la pestaña es la activa y el navegador no está
//    minimizado ni totalmente tapado.
//  - hasFocus(): la ventana del navegador es la ventana activa del sistema. Sin esto,
//    una ventana tapada en parte por otra app seguiría contando como vista.
// Se usa para no marcar como leídos mensajes que llegan mientras nadie ve el chat.
// Ojo al probar: con el foco en DevTools, hasFocus() devuelve false.
export function isTabActive() {
  return document.visibilityState === 'visible' && document.hasFocus();
}
